import { User } from "@angular/fire/auth";
import { FieldValue, Timestamp } from "@angular/fire/firestore";

export interface UserProfile {
    id:string;
    userName:string;
    displayName:string;
    imageUrl:string;
    joinDate:Date;
    bio:string;
    ideology:'left'|'right'|'center';
    birthYear:number;
    karma: number;
    posts: number;
}

export type UserToken = Pick<UserProfile,"id"|"displayName"|"imageUrl">;

export type UserMemberShip = UserToken & {
    id:UserProfile['id'];
    subscription?:boolean;
    numPosts?:number|FieldValue;
};

export type UserRating = UserToken & {
    id:UserProfile['id'];
    upVote?:number;
    downVote?:number;
    challenge?:string;
};

export type RegistrationEvent = {
    authUser: User;
    localProfile: Partial<UserProfile> & {
        id: string;
    };
}

export const UserProfileUtil = {
    COLLECTION: 'UserProfile',
    create:(user:Partial<User>)=>{
        const newUser:Partial<UserProfile> = {
            displayName: user.displayName ?? 'New User',
            imageUrl: user.photoURL ?? '',        };
        if (user.uid) newUser.id = user.uid;
        return newUser as UserProfile;
    },

    displayAge(year:number|undefined){
        
        if (Number.isSafeInteger(year)) {
            const thisYear = (new Date()).getFullYear();
            return Number(year) - thisYear;
        }
        return "Not Specified";
    },

    asToken(userObj:Partial<UserProfile>|null|undefined) {
        if  (userObj){
            return {
                id: userObj.id,
                displayName: userObj.displayName,
                imageUrl: userObj.imageUrl,
            } as UserToken;

        }
        throw {}
    }

}